import { render, staticRenderFns } from "./propagandaMonthlyStatisticsDetail.vue?vue&type=template&id=22f1d978"
import script from "./propagandaMonthlyStatisticsDetail.vue?vue&type=script&lang=js"
export * from "./propagandaMonthlyStatisticsDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports